import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { Input } from '@cfacorp/cowponents';

export const DeliveryTipsCustomAmount = (props) => {
  const {
    isSelect,
    onBlurHandler,
    beforeInputHandler,
    onInputHandler,
    onKeyDownHandler,
    selectedCustomTipValue,
  } = props;

  return (
    <StyledCustomTipAmount
      isSelect={isSelect}
      selectedCustomTipValue={selectedCustomTipValue}
      className="styled-custom-tip-amount"
    >
      <Input
        type="number"
        height="44px"
        id="customTip"
        p="1px 1px 1px 20px"
        placeholder="0.00"
        onBlur={onBlurHandler}
        onInput={onInputHandler}
        onBeforeInput={beforeInputHandler}
        onKeyDown={onKeyDownHandler}
        width="calc(100% - 10px)"
        m="5px"
        defaultValue={selectedCustomTipValue !== 0 ? selectedCustomTipValue : ''}
        className="custom-amount-input"
        min={0}
        step={0.01}
        max={99999}
      />
    </StyledCustomTipAmount>
  );
};

DeliveryTipsCustomAmount.propTypes = {
  isSelect: PropTypes.bool,
  onBlurHandler: PropTypes.func,
  onInputHandler: PropTypes.func,
  beforeInputHandler: PropTypes.func,
  onKeyDownHandler: PropTypes.func,
  selectedCustomTipValue: PropTypes.number,
};

DeliveryTipsCustomAmount.defaultProps = {
  isSelect: false,
  onBlurHandler: () => {},
  onInputHandler: () => {},
  beforeInputHandler: () => {},
  onKeyDownHandler: () => {},
  selectedCustomTipValue: 0,
};

export const StyledCustomTipAmount = styled('div')`
  position: relative;
  ${Input} {
    border: solid 1px #5b6770;
  }
  & input {
    text-align: left;
    border-radius: 6px;
    padding: 0px 4px 0px 25px;
  }
  &::after {
    content: '$';
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translate(0, -50%);
  }
`;

export default DeliveryTipsCustomAmount;
